import { CREDIT_RATING_MODELS } from '../../shared/screener-constants';
import format from '../../utils/format';

const creditRating = () => {
  return {
    [CREDIT_RATING_MODELS.SP]: {
      heading: 'Standard & Poor’s',
      bars: [false, false, false, true, false],
      rating: 'AA+',
      asOfDate: format.date('2024-05-29')
    },
    [CREDIT_RATING_MODELS.MOODY]: {
      heading: 'Moody’s Investors Service',
      bars: [false, false, false, true, false],
      rating: 'Aa1',
      asOfDate: format.date('2024-10-15')
    },
    [CREDIT_RATING_MODELS.AMBEST]: {
      heading: 'A.M. Best Company',
      bars: [false, false, false, true],
      rating: 'A++',
      asOfDate: format.date('2024-07-25')
    },
    [CREDIT_RATING_MODELS.FITCH]: {
      heading: 'Fitch',
      bars: [false, false, false, false, true],
      rating: 'AAA',
      asOfDate: format.date('2024-08-16')
    }
  };
};

export default creditRating;
